// extracted by mini-css-extract-plugin
module.exports = {"crossSiteLabel":"Rh","zenCrossSiteLabel":"Sh","vrsnlCrossSiteLabel":"Th"};